const staticLookups = {
    teamData: {
        "553": {
            "name": "Richard Childress Racing",
            "image": "./assets/imgs/team-logos/richard-childress-racing.png",
        },
        "915": {
            "name": "",
            "image": "./assets/imgs/team-logos/empty-team.png",
        },
        "1464": {
            "name": "Hendrick Motorsports",
            "image": "./assets/imgs/team-logos/hendrick-motorsports.png",
        },
        "1717": {
            "name": "Legacy Motor Club",
            "image": "./assets/imgs/team-logos/legacy-motor-club.png",
        },
        "3078": {
            "name": "Hyak Motorsports",
            "image": "./assets/imgs/team-logos/hyak-motorsports.jpg",
        },
        "3486": {
            "name": "Rick Ware Racing",
            "image": "./assets/imgs/team-logos/rick-ware-racing.png",
        },
        "4047": {
            "name": "Joe Gibbs Racing",
            "image": "./assets/imgs/team-logos/joe-gibbs-racing.png",
        },
        "4084": {
            "name": "Haas Factory Team",
            "image": "./assets/imgs/team-logos/haas-factory-team.png",
        },
        "4184": {
            "name": "Front Row Motorsports",
            "image": "./assets/imgs/team-logos/front-row-motorsports.png",
        },
        "4414": {
            "name": "Team Penske",
            "image": "./assets/imgs/team-logos/team-penske.png",
        },
        "4493": {
            "name": "RFK Racing",
            "image": "./assets/imgs/team-logos/rfk-racing.jpg",
        },
        "4997": {
            "name": "Front Row Motorsports",
            "image": "./assets/imgs/team-logos/front-row-motorsports.png",
        },
        "5061": {
            "name": "RFK Racing",
            "image": "./assets/imgs/team-logos/rfk-racing.jpg",
        },
        "5229": {
            "name": "Trackhouse Racing",
            "image": "./assets/imgs/team-logos/trackhouse-racing.png",
        },
        "6001": {
            "name": "",
            "image": "./assets/imgs/team-logos/empty-team.png",
        },
        "6521": {
            "name": "Front Row Motorsports",
            "image": "./assets/imgs/team-logos/front-row-motorsports.png",
        },
        "7087": {
            "name": "Kaulig Racing",
            "image": "./assets/imgs/team-logos/kaulig-racing.png",
        },
        "7093": {
            "name": "",
            "image": "./assets/imgs/team-logos/empty-team.png",
        },
        "7552": {
            "name": "Wood Brothers Racing",
            "image": "./assets/imgs/team-logos/wood-brothers-racing.png",
        },
        "7566": {
            "name": "Front Row Motorsports",
            "image": "./assets/imgs/team-logos/front-row-motorsports.png",
        },
        "7712": {
            "name": "23XI Racing",
            "image": "./assets/imgs/team-logos/23xi-racing.png",
        },
        "7732": {
            "name": "",
            "image": "./assets/imgs/team-logos/empty-team.png",
        },
        "7958": {
            "name": "",
            "image": "./assets/imgs/team-logos/empty-team.png",
        },
        "8056": {
            "name": "",
            "image": "./assets/imgs/team-logos/empty-team.png",
        },
    },
    manufacturerBadges: {
        "Toyota": {
            src: "./assets/imgs/toyota-logo.png",
            width: "40px",
            height: "40px"
        },
        "Chevrolet": {
            src: "./assets/imgs/chevy-logo.png",
            width: "40px",
            height: "40px"
        },
        "Ford": {
            src: "./assets/imgs/ford-logo.png",
            width: "52px",
            height: "24px"
        }
    },
    flags: {
        "0": {
            "name": "none",
            "color": "#000000",
            "image": "./assets/imgs/flag-solid.svg"
        },
        "1": {
            "name": "green",
            "color": "#46ff46",
            "image": "./assets/imgs/flag-solid.svg"
        },
        "2": {
            "name": "yellow",
            "color": "#fffc4f",
            "image": "./assets/imgs/flag-solid.svg"
        },
        "3": {
            "name": "red",
            "color": "#e73636",
            "image": "./assets/imgs/flag-solid.svg"
        },
        "4": {
            "name": "checkered",
            "color": "#FFFFFF",
            "image": "./assets/imgs/flag-checkered-solid.svg"
        },
        "8": {
            "name": "warmup",
            "color": "#AAAAAA",
            "image": "./assets/imgs/flag-solid.svg"
        },
        "0": {
            "name": "notactive",
            "color": "#000000",
            "image": "./assets/imgs/flag-solid.svg"
        }
    }
};

export default staticLookups;
